import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW6000Model } from './kymw6000.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { VMediumTypeComboBoxComponent } from '../../../commons/kymw02/combo-box/vmedium-type-combo-box/vmedium-type-combo-box.component';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { GetFeatureThemaListService } from './api-services/get-feature-thema-list.service';
import { Router } from '@angular/router';
import { GetCwsPlanGoodsUseImageGroupDispListService } from './api-services/get-cws-plan-goods-use-image-group-disp-list.service';
import { CwsPlanGoodsUseImageGrioupListService } from './list-service/cwsPlanGoodsUseImageGroupList.service';
import { GetMediumListPlanGoodsFlagService } from 'src/app/commons/kymw02/combo-box/plan-medium-type-combo-box/api-services/get-medium-list-plan-goods-flag.service';
import { PlanMediumTypeComboBoxModel } from 'src/app/commons/kymw02/combo-box/plan-medium-type-combo-box/plan-medium-type-combo-box.model';
import { PlanMediumTypeComboBoxComponent } from 'src/app/commons/kymw02/combo-box/plan-medium-type-combo-box/plan-medium-type-combo-box.component';

/**
 * EC使用画像一覧表画面を管理するクラス
 *
 * @export KYMW6000Component
 * @class KYMW6000Component
 */
@Component({
  selector: 'app-kymw6000',
  templateUrl: 'kymw6000.component.html',
  styleUrls: ['kymw6000.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW6000Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: VMediumTypeComboBoxComponent;

  // 親画面からの連携値
  param: any;

  kymw6000Model: KYMW6000Model = new KYMW6000Model();

  // 媒体取得用APIに使用するModel
  public planMediumTypeModel: PlanMediumTypeComboBoxModel = new PlanMediumTypeComboBoxModel();

  public enabled = null;
  
  // チェックボックス選択制御
  public multiOrCrossSelected: boolean = <boolean>false;
  public imageNoUseSelected: boolean = <boolean>false;
  public imageCheckSelected: boolean = <boolean>false;

  /**
   * Creates an instance of KYMW6000Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {GetCwsPlanGoodsUseImageGroupDispListService} getCwsPlanGoodsUseImageGroupDispListService
   * @memberof KYMW6000Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getFeatureThemaListService: GetFeatureThemaListService,
    private getCwsPlanGoodsUseImageGroupDispListService: GetCwsPlanGoodsUseImageGroupDispListService,
    private route: Router,
    private cwsPlanGoodsUseImageGroupListService: CwsPlanGoodsUseImageGrioupListService,
    private getMediumListPlanGoodsFlagService: GetMediumListPlanGoodsFlagService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW6000';

    this.enabled = true;

    this.initKYMW6000();

    // 媒体リスト取得
    this.getMediumList();
  }

  /**
   * 画面情報の初期化
   */
  public initKYMW6000(): void {
    // 受注コードをクリアに連動して、配達企画回（翌週）がクリア、媒体が再作成される。
    this.kymw6000Model.orderCode = '';
  }

  /**
   * メニュー「最新の情報に更新」押下時の処理
   *
   */
  public reloadKYMW6000(): void {
    this.initKYMW6000();
  }

  /**
   * 受注コード(テキストインプット)_変更時に呼び出される
   *
   */
  public eventOrderCode_CHANGEHandler(): void {
    if(!PlessViewUtilsSub.isEmpty(this.kymw6000Model.mediumType) && 
        this.txti_OrderCode.isValidOrderCode()) {
      // 特集リスト取得
      this.getFeatureThemaListService.execute(this.kymw6000Model);
    } else {
      this.kymw6000Model.FeatureList = [];
    }
    this.kymw6000Model.featureCode = '';
  }

  /**
   * 媒体(コンボボックス)_変更時に呼び出される
   *
   */
  public eventCmbMedium_CHANGEHandler(): void {
    if (this.kymw6000Model.mediumType === 'blankVal') this.kymw6000Model.mediumType = '';

    if (!PlessViewUtilsSub.isEmpty(this.kymw6000Model.mediumType) && 
        this.txti_OrderCode.isValidOrderCode()) {
      // 特集リスト取得
      this.getFeatureThemaListService.execute(this.kymw6000Model);
    } else {
      this.kymw6000Model.FeatureList = [];
    }
    this.kymw6000Model.featureCode = '';
  }

  /**
   * 特集コード(コンボボックス)_変更時に呼び出される
   * 
   */
  public eventFeatureCode_CHANGEHandler(): void {
    if (this.kymw6000Model.featureCode === 'blankVal') this.kymw6000Model.featureCode = '';
  }

  /**
   * 表示ボタン押下時処理
   *
   */
  public eventDisplay_CLICKHandler(): void {

    // 入力チェック
    if(!this.inputCheck()) {
      return;
    }

    // 企画回を格納
    const element = document.getElementById("lbl_CatalogId") as HTMLInputElement;
    this.kymw6000Model.catalogId = element.value;

    // チェックボックスが選択されている場合は、「1:選択」とする
    this.kymw6000Model.multiOrCrossFlg = this.multiOrCrossSelected === true ? '1' : '0';
    this.kymw6000Model.imageNoUseFlg = this.imageNoUseSelected === true ? '1' : '0';
    this.kymw6000Model.imageCheckFlg = this.imageCheckSelected === true ? '1' : '0';

    // 存在チェック
    this.getCwsPlanGoodsUseImageGroupDispListService.execute(this.kymw6000Model, (data: any) => {
      if (data.GoodsUseImageList.length > 0) {
        this.cwsPlanGoodsUseImageGroupListService.imageList = data;
        // 商品画像情報画面に遷移
        this.route.navigate(['/kymw/6001'], {
          queryParams: {
            orderCode: this.kymw6000Model.orderCode,
            mediumType: this.kymw6000Model.mediumType,
            mediumName: this.getComboName("cmb_Medium"),
            catalogId: this.kymw6000Model.catalogId,
            classCode: this.kymw6000Model.classCode,
            className: this.getComboName("cmb_ClassCode"),
            pCode: this.kymw6000Model.pCode,
            featureCode: this.kymw6000Model.featureCode,
            featureName: this.getComboName("cmb_FeatureCode"),
            multiOrCrossFlg: this.kymw6000Model.multiOrCrossFlg,
            imageNoUseFlag: this.kymw6000Model.imageNoUseFlg,
            imageCheckFlag: this.kymw6000Model.imageCheckFlg,
            page: 1,
          },
        });
      } else {
        this.dialogService.openAlertGetMessage('E0100', []);
      }
    });
  }

  /**
   * コンボボックスから選択された名称を取得
   * 
   * @param idName 
   * @returns 
   */
  getComboName(idName: string) {
    const element = document.getElementById(idName)
    const selectElement = element.firstElementChild as HTMLSelectElement;
    if (selectElement.options[selectElement.selectedIndex] != undefined) {
      const text = selectElement.options[selectElement.selectedIndex].text
      return text.split(':')[1];
    } else {
      return "";
    }
  }

  /**
   * 入力チェック
   *
   * @return true:OK false:NG
   */
  public inputCheck(): boolean {
    // 受注コード必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw6000Model.orderCode)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード']);
      return false;
    }
    // 受注コード存在チェック
    if (PlessViewUtilsSub.isEmpty(this.txti_OrderCode.selectedCatalogID)) {
      this.dialogService.openAlertGetMessage('E0122', ['受注コード']);
      return false;
    }
    // 媒体必須チェック
    // 媒体は必須リクエストから外すためコメントアウト
    /*if (PlessViewUtilsSub.isEmpty(this.kymw6000Model.mediumType)) {
      this.dialogService.openAlertGetMessage('W0001', ['媒体区分']);
      return false;
    }*/
    // Pコードフォーマットチェック
    if (!PlessViewUtilsSub.isEmpty(this.kymw6000Model.pCode)) {
      if (!PlessViewUtilsSub.validatePCode(this.kymw6000Model.pCode)) {
        this.dialogService.openAlertGetMessage('W0024', ['Pコード']);
        return false;
      }
    }
    return true;
  }
  
  /**
   * 媒体リスト取得
   */
  public getMediumList(): void {
    // コンボボックスインスタンス設定
    this.planMediumTypeModel.component = new PlanMediumTypeComboBoxComponent(this.elementRef, this.getMediumListPlanGoodsFlagService);
    // API実行で取得するリストはblankをfalseにする（html側で使用するversatile-combo-boxではtrueとする）
    this.planMediumTypeModel.blank = false;
    // API実行
    this.getMediumListPlanGoodsFlagService.execute(this.planMediumTypeModel, '', () => {
      // 媒体リストから媒体コード「017」「030」「031」「075」「076」を削除する
      const mediumTypeList = this.planMediumTypeModel.mediumList.filter(m => {
        if (m.MediumType === '017' || m.MediumType === '030' || m.MediumType === '031' || m.MediumType === '075' || m.MediumType === '076') {
          return false;
        } else {
          return true;
        }
      });
      // listSourceで使用するリストに格納
      this.kymw6000Model.mediumList = mediumTypeList;
    });
  }
}
